export const storeKinds = {
  ACADEMY: 'academy',
  ADVENTURE: 'adventure',
  AIRFORCE: 'airforce',
  ALTERNATIVE: 'alternative',
  ARMY: 'army',
  BASEBALL_INDEPENDENT: 'baseball_independent',
  BASEBALL_INTERNATIONAL: 'baseball_international',
  COASTGUARD: 'coastguard',
  COLLEGE: 'college',
  COLLEGE_TM: 'college_tm',
  COLMASCOT: 'colmascot',
  DESTINATION: 'destination',
  ELEMENTARY: 'elementary',
  FANTASY: 'fantasy',
  FEDERAL: 'federal',
  FIRE: 'fire',
  FRATERNITY: 'fraternity',
  GOLF: 'golf',
  GREEK: 'greek',
  HIGH: 'high',
  LITTLELEAGUE: 'littleleague',
  MARINES: 'marines',
  MARSHAL: 'marshal',
  MIDDLE: 'middle',
  MILITARY: 'military',
  MUSIC: 'music',
  NATIONALGUARD: 'nationalguard',
  NAVY: 'navy',
  PARKSANDREC: 'parksandrec',
  PERSONAL: 'personal',
  PET: 'pet',
  POLICE: 'police',
  PROAUSFOOTBALL: 'proausfootball',
  PROBASEBALL: 'probaseball',
  PROBASKETBALL: 'probasketball',
  PROCITIES: 'procities',
  PROFOOTBALL: 'profootball',
  PROHOCKEY: 'prohockey',
  PROLACROSSE: 'prolacrosse',
  PROMASCOT: 'promascot',
  PRORUGBY: 'prorugby',
  PROSPORTS: 'prosports',
  PUBLICNONAME: 'publicnoname',
  RACES: 'races',
  RUGBY: 'rugby',
  SHERIFF: 'sheriff',
  SORORITY: 'sorority',
  TEAM2: 'team2',
  TEAM: 'team',
  TROOPER: 'trooper',
  UNIVERSITY: 'university',
  UNIVERSITY_TM: 'university_tm',
  UNKNOWN: 'unknown',
  VINTAGE: 'vintage',
  VINTAGETEAMS: 'vintageteams',
  WORLDSOCCER: 'worldsoccer'
}

export const adminForms = {
  W9: 'form-w9'
}
